import { authApi } from './auth'

const mfaAPi = authApi.injectEndpoints({
  endpoints: (builder) => ({
    registerMFA: builder.query<
      {
        totp_uri: string
      },
      void
    >({
      query: () => ({
        url: '/auth/mfa/registration',
        method: 'POST',
        data: {
          type: 'totp',
        },
        withCredentials: false,
        errorOverride: true,
      }),
    }),
    activateMfa: builder.mutation<
      void,
      {
        type: 'totp'
        value: string
      }
    >({
      query: (data) => ({
        url: `/auth/mfa/activation`,
        method: 'POST',
        data,
        withCredentials: false,
        errorOverride: true,
      }),
    }),
    verifyMFA: builder.mutation<void, { type: 'totp'; value: string }>({
      query: (data) => ({
        url: `/auth/mfa/verification`,
        method: 'POST',
        data,
        withCredentials: false,
        errorOverride: true,
      }),
    }),
    deactivateMFA: builder.mutation<void, { type: 'totp'; value: string }>({
      query: (data) => ({
        url: `/auth/mfa/deactivation`,
        method: 'POST',
        data,
        withCredentials: false,
        errorOverride: true,
      }),
    }),
  }),
})

export const {
  useRegisterMFAQuery,
  useActivateMfaMutation,
  useVerifyMFAMutation,
  useDeactivateMFAMutation,
} = mfaAPi
